export const arrayToObject = <T>(key: string, items: T[]) =>
  items.reduce<Record<string, T>>((prev, curr) => {
    prev[(curr as any)[key]] = curr;
    return prev;
  }, {});
